import React, { useState, FC, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import RegisterImage from '../../../images/register-left.png';
import GoogleIcon from '../../../images/google-icon.png';
import FacebookIcon from '../../../images/facebook-icon.png';
import AppleIcon from '../../../images/apple-icon.png';
import { useHistory, withRouter, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  doSignIn,
  doFetchProfile,
  doSocialSignIn,
} from '../../../actions/authAction';
import { GoogleLogin } from 'react-google-login';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props';
import { Form, Button } from 'react-bootstrap';

import { ModalFailedLogin, ModalLoginAttempt } from '../../Modals';

interface History {
  push: (args: string) => any;
  replace: (args: string) => any;
}

type Fetch = () => any;

type LoginPageProps = {
  history: History;
  login: (obj: Object) => any;
  socialLogin: (args: Object) => any;
  fetch: Fetch;
  errors: Object;
  countdown_modal?: boolean;
};

interface FacebookUser {
  id: number;
  email: string;
  password: string;
  oauth_token: string;
  type: string;
  name: string;
  accessToken: string;
}

interface ProfileObject {
  googleId: number;
  email: string;
  name: string;
}

interface googleUser {
  tokenId: number;
  profileObj: ProfileObject;
  accessToken: string;
}
interface Value {
  value: string;
}
interface Event {
  target: Value;
}

const PageLoginV3: FC<LoginPageProps> = ({
  login,
  socialLogin,
  fetch,
  e,
  isLogged,
  countdown_modal,
}) => {
  const history = useHistory();
  const location = useLocation();
  const queries = new URLSearchParams(location.search);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState([]);
  const [passwordError, setPasswordError] = useState([]);
  const [isDisabled, setIsDisabled] = useState(true);
  const [redirectTo, setRedirectTo] = useState(
    location.search
      ? queries.get('next')
      : location.state && location.state.next
      ? location.state.next
      : '/',
  );

  const [authCode, setAuthCode] = useState('');
  const [renderAuthCode, setRenderAuthCode] = useState(false);
  const [errorForInputAuth, setErrorForInputAuth] = useState('');

  const [_googleUser, setGoogleUser] = useState(null);
  const [_facebookUser, setFacebookUser] = useState(null);
  const [_login, setLogin] = useState(null);

  const [isOpenModalFailedLogin, setOpenModalFailedLogin] = useState(false);
  const [errorLoginMsg, setErrorLoginMessage] = useState('');
  const [remainingAttempts, setRemainingAttempts] = useState(0);
  const [isOpenModalRemaining, setIsOpenModalRemaining] = useState(false);

  useEffect(() => {
    setErrorLoginMessage('');
    setRemainingAttempts(0);
    setIsOpenModalRemaining(false);
    setOpenModalFailedLogin(false);

    if (e?.message === 'Must provide 2FA code') {
      setRenderAuthCode(true);
    } else if (e?.message === 'Incorrect 2FA code') {
      setErrorForInputAuth('Incorrect 2FA code');
      setRenderAuthCode(true);
    } else if (
      e?.message === 'Your account is locked. Please reset your password!'
    ) {
      setErrorLoginMessage(e?.message);
      setOpenModalFailedLogin(true);
    } else if (e?.attempts_remaining > 0) {
      setRemainingAttempts(e?.attempts_remaining || 0);
      setIsOpenModalRemaining(true);
    } else {
      if ((e && e.errors) || e?.message) {
        setRenderAuthCode(false);
        setGoogleUser(null);
        setFacebookUser(null);
        setLogin(null);
        setAuthCode('');
      }

      if (e && e.errors) {
        let keys = Object.keys(e.errors);

        for (let i = 0; i < keys.length; i++) {
          if (keys[i] === 'email') {
            setEmailError(e.errors.email);
          } else {
            setPasswordError(e.errors.password);
          }
        }
      } else {
        let errMsg: any = [
          e?.message === 'Invalid Credentials'
            ? 'Wrong password entered. Please try again'
            : e?.message || '',
        ];
        setPasswordError(errMsg);
      }
    }
  }, [e]);

  useEffect(() => {
    if (
      isLogged &&
      !history.location?.state?.isFromProductDetail &&
      !history.location?.state?.isFromRafflePage
    ) {
      history.push('/');
    }
  }, [isLogged]);

  useEffect(() => {
    if (email && password) {
      setIsDisabled(false);
    } else {
      setIsDisabled(true);
    }
  }, [email, password]);

  function onChangeEmail(e: Event) {
    setEmail(e.target.value);
  }

  function onChangePassword(e: Event) {
    setPassword(e.target.value);
  }

  function goToRegisterPage() {
    history.push('/register');
  }

  function goToForgotPasswordPage() {
    history.push('/forgot-password');
  }

  function handleSignInSuccess(isReplace: boolean) {
    const changeUrl = !isReplace ? history.push : history.replace;
    if (history.location.state?.isFromProductDetail) {
      changeUrl({
        pathname: history.location.state.redirectPath,
        search: history.location.state.redirectSearch,
        state: {
          selectedCondition: history.location.state.selectedCondition,
        },
      });
    } else if (history.location.state?.isFromRafflePage) {
      changeUrl({
        pathname: history.location.state?.redirectPath,
      });
    } else {
      changeUrl(redirectTo);
    }
  }

  function handleSignIn(type, data) {
    switch (type) {
      case 'regular': {
        setEmailError([]);
        setPasswordError([]);
        setLogin({
          email,
          password,
        });

        setGoogleUser(null);
        setFacebookUser(null);
        const payload = {
          email,
          password,
          google_2fa: authCode,
        };

        login(payload)
          .then((_) => {
            fetch();
            handleSignInSuccess(true);
          })
          .catch((e: string) => null);
        return;
      }
      case 'facebook': {
        setLogin(null);
        setGoogleUser(null);

        const usedData = data ? data : _facebookUser;
        if (!usedData.hasOwnProperty('status')) {
          setFacebookUser(usedData);

          const dataUser = {
            id: usedData.id,
            email: usedData.email,
            typed_email: usedData.email,
            type: 'facebook',
            oauth_token: usedData.accessToken,
            name: usedData.name,
            google_2fa: authCode,
          };

          socialLogin(dataUser)
            .then((_) => {
              fetch();
              handleSignInSuccess();
            })
            .catch((e) => null);
        }
        return;
      }
      case 'google': {
        setLogin(null);
        setFacebookUser(null);
        // console.log(_googleUser, "_googleUser")
        const usedData = data ? data : _googleUser;
        if (!usedData.hasOwnProperty('error')) {
          setGoogleUser(usedData);
          const { tokenId, profileObj } = usedData;
          const dataUser = {
            id: profileObj.googleId,
            email: profileObj.email,
            typed_email: profileObj.email,
            oauth_token: tokenId,
            type: 'google',
            name: profileObj.name,
            google_2fa: authCode,
          };

          socialLogin(dataUser)
            .then((_) => {
              fetch();
              handleSignInSuccess();
            })
            .catch((e) => null);
        }
        return;
      }
      default:
        null;
    }
  }

  function signIn(e: any) {
    e.preventDefault();
    setLogin({
      email,
      password,
    });
    handleSignIn('regular', {
      email,
      password,
    });
  }

  function loginFacebook(facebookUser: FacebookUser) {
    if (!facebookUser.hasOwnProperty('status')) {
      setFacebookUser(facebookUser);
      handleSignIn('facebook', facebookUser);
    }

    return null;
  }

  function loginFacebookFailed() {
    return null;
  }

  function loginGoogleFailed() {
    return null;
  }

  function loginGoogle(googleUser: googleUser) {
    if (!googleUser.hasOwnProperty('error')) {
      setGoogleUser(googleUser);
      handleSignIn('google', googleUser);
    }

    return null;
  }

  function reSubmitWithCode(e: any) {
    e.preventDefault();
    if (_login) {
      handleSignIn('regular');
    } else if (_facebookUser) {
      if (!_facebookUser.hasOwnProperty('status')) {
        handleSignIn('facebook');
      }
      return;
    } else if (_googleUser) {
      handleSignIn('google');
      return;
    }
  }

  return (
    <div
      className={
        countdown_modal ? 'page-login is-countdown-active' : 'page-login'
      }
      style={{ paddingTop: window.screen.availWidth > 480 ? '7rem' : '5rem' }}
    >
      <div className="login-left-side">
        <KickImage src={RegisterImage} alt="" />
        <h4>What are you waiting for?</h4>
        <h5>Immerse yourself in the latest trend in fashion</h5>
      </div>
      {!renderAuthCode ? (
        <div className="login-right-side">
          <Form onSubmit={signIn}>
            <div className="login-title">
              <h4>Login</h4>
              <h5>
                Don't have an account?{' '}
                <span onClick={() => goToRegisterPage()}>Sign up here</span>
              </h5>
            </div>
            <div className="form-section">
              <input
                onChange={onChangeEmail}
                value={email}
                placeholder="Email Address"
                type="email"
              />
              {emailError &&
                emailError.length > 0 &&
                emailError.map((item) => (
                  <p className="email-error">{emailError}</p>
                ))}
              <input
                onChange={onChangePassword}
                value={password}
                placeholder="Password"
                type="password"
              />
              {passwordError &&
                passwordError.length > 0 &&
                passwordError.map((item: string) => (
                  <p className="password-error">{item}</p>
                ))}

              <input
                style={{
                  color: isDisabled ? '#939393' : '#fff',
                  backgroundColor: isDisabled ? '#ebebeb' : '#159953',
                  fontFamily: 'Nunito-Regular',
                  borderRadius: '50px',
                  fontSize: '18px',
                  padding: window.screen.availWidth < 480 ? '10px' : '16px',
                }}
                value="Login"
                type={isDisabled ? 'button' : 'submit'}
              />
            </div>
            <div className="forgot-password">
              <h6 onClick={() => goToForgotPasswordPage()}>Forgot password?</h6>
            </div>
            <div className="social-signIn-desc">
              <h5>Login instantly using your social media</h5>
            </div>
          </Form>
          <div className="social-login">
            <FacebookLogin
              appId="1588115344582034"
              fields="name,email,verified"
              version="2.12"
              disableMobileRedirect={true}
              scope="public_profile,email"
              onFailure={loginFacebookFailed}
              callback={loginFacebook}
              render={(props) => (
                <div onClick={props.onClick} className="social-button">
                  <KickImage style={{ width: '8px' }} src={FacebookIcon} alt="" />
                </div>
              )}
            />
            <GoogleLogin
              clientId="594858415021-kion5vibkgo9kf91toajjcb6h7ltt4aq.apps.googleusercontent.com"
              onSuccess={loginGoogle}
              onFailure={loginGoogleFailed}
              className="social-button"
            >
              <KickImage src={GoogleIcon} alt="" />
            </GoogleLogin>
          </div>
        </div>
      ) : (
        <form className="multi-factor-auth-wrapper" onSubmit={reSubmitWithCode}>
          <p className="title">Multi-factor Authentication</p>
          <p className="sub-title">Enter an 2FA code to complete sign-in.</p>
          <p className="label">2FA Code:</p>
          <input
            autoComplete="off"
            onChange={(e) => setAuthCode(e.target.value)}
            value={authCode}
            type="text"
            name="name"
          />
          {errorForInputAuth ? (
            <p className="auth-error">{errorForInputAuth}</p>
          ) : null}
          <Button
            type="submit"
            disabled={!authCode ? true : false}
            className="submit"
          >
            Submit
          </Button>
        </form>
      )}

      {isOpenModalRemaining ? (
        <ModalLoginAttempt
          remainingAttempt={remainingAttempts}
          show={isOpenModalRemaining}
          onHide={() => setIsOpenModalRemaining(!isOpenModalRemaining)}
        />
      ) : null}
      {isOpenModalFailedLogin ? (
        <ModalFailedLogin
          show={isOpenModalFailedLogin}
          onHide={() => setOpenModalFailedLogin(!isOpenModalFailedLogin)}
          resetPassword={() => goToForgotPasswordPage()}
        />
      ) : null}
    </div>
  );
};

interface LoginParameter {
  email: string;
  password: string;
  google_2fa?: string;
}

const mapStateToProps = (state) => ({
  e: state.dataAuth.signIn.error,
  _signIn: state.dataAuth.signIn,
  isLogged: state.dataAuth.isLogged,
  countdown_modal: state.dataMenu.countdown_modal,
});

const mapDispatchToProps = (dispatch: any) => ({
  login: (payload: LoginParameter) => dispatch(doSignIn(payload)),
  socialLogin: (user: Object) => dispatch(doSocialSignIn(user)),
  fetch: () => dispatch(doFetchProfile()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(PageLoginV3));
